import common from './common-educabot'

export default {
  ...common.button,
  color: `#01CEAA`,
  '::before': {
    display: `none`
  },
  '::after': {
    ...common.button['::after'],
    bg: `white`,
    border: '0.5px solid',
    borderColor: `#01CEAA`
  }
}